module.exports = {"pageTitleText":"支持"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/support.json
// module id = KfPZ
// module chunks = 3